import React from "react";

interface LinearBarProps {
  percent: number;
  barClass?: string;
  trackClass?: string;
  heightClass?: string;
  label?: React.ReactNode;
}

const LinearBar: React.FC<LinearBarProps> = ({
  percent,
  barClass = "bg-emerald-500",
  trackClass = "bg-slate-200",
  heightClass = "h-3",
  label,
}) => {
  const p = Math.max(0, Math.min(100, percent));
  
  return (
    <div className="w-full">
      <div className={`relative w-full ${heightClass} ${trackClass} rounded-full overflow-hidden`}>
        <div
          className={`absolute left-0 top-0 ${heightClass} ${barClass}`}
          style={{ width: `${p}%` }}
        />
      </div>
      {label ? <div className="mt-1 text-sm text-slate-700">{label}</div> : null}
    </div>
  );
};

export default LinearBar;
